import { DatalayerHelper } from './ib-datalayer-helper';

@Service('ib-web-ancillaries-module',
    ['localStorageService', 'CommonsUtilService', 'DatalayerUtilsService', 'DatalayerHelper', 'AncillariesConstants'],
    ['ib-commons-constants-module', 'ib-monetate-module'])
export class SeatsDatalayerUtils {
    seatSelectedId: string[] = [];
    seatSelectedType: string[] = [];
    segmentId: string;
    constructor (
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CommonsUtilService: CommonsUtilService,
        private DatalayerUtilsService: DatalayerUtilsService,
        private DatalayerHelper: DatalayerHelper,
        private AncillariesConstants: AncillariesConstant

    ) { }


    getSeatsItemBrand (selectedTripInfo, itemCategory2) {
        return selectedTripInfo ? selectedTripInfo[0].info.segments[0].flight.operationalCarrier.name.toLowerCase() : this.DatalayerHelper.getBrandItem(itemCategory2, null);
    }
    getSeatsQuantity (anc, seatMapSegmentId) {
        return anc.segments.find(segment => segment.id === seatMapSegmentId)?.passengers?.length;
    }
    getDataEcommerceForSeats (seatPrice, anc) {
        const id = this.CommonsUtilService.getIdItem('all');
        const selectedTripInfo: any = this.localStorageService.get('selectedTripInfo');
        const itemCategory2: string = this.getTripBySeats();
        const seatMap: any = this.localStorageService.get('seatMap');
        const {segmentId:seatMapSegmentId} = seatMap;
        const item: DigitalDataEcommerceModel.Item = {
            item_name: 'seat',
            item_id: id,
            price: seatPrice.amount,
            item_brand: this.getSeatsItemBrand(selectedTripInfo, itemCategory2),
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: itemCategory2,
            item_category3: this.DatalayerUtilsService.getItemCategory3('seat', itemCategory2, id),
            item_variant: seatPrice.type.toLowerCase(),
            quantity: this.getSeatsQuantity(anc, seatMapSegmentId)
        };
        return item;
    }

    private getTripBySeats = (): string => {
        const flowApp = this.localStorageService.get('flowApp');
        const seatInfoConfirmation: any = this.localStorageService.get('seatInfoConfirmation');
        const segmentsInfo: any = this.localStorageService.get('segmentsInfo');
        let trip: string = '';
        let seatMap: any = null;

        if (flowApp === this.AncillariesConstants.APPLICATION_FLOW.CHECKIN) {
            seatMap = this.localStorageService.get('seatMapSegment');
        } else {
            seatMap = this.localStorageService.get('seatMap');
        }

        if (segmentsInfo) {
            segmentsInfo.forEach(segment => {
                if (segment?.id === seatMap?.segmentId) {
                    trip = segment?.origin?.code + '-' + segment?.destination?.code;
                }
            });
        } else if (seatInfoConfirmation) {
            seatInfoConfirmation?.segments.forEach(segment => {
                if (segment?.id === seatMap?.segmentId) {
                    trip = segment?.departure?.code + '-' + segment?.arrival?.code;
                }
            });
        }

        return trip;
    };

    setSeatSelectItem = (model: any, seatSelected: any): DigitalDataEcommerceModel.Item => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        const id: string = this.CommonsUtilService.getIdItem('all');
        const itemCategory2: string = model?.seatMapInfo?.segmentInfo?.departure?.code + '-' + model?.seatMapInfo?.segmentInfo?.arrival?.code;
        const item: DigitalDataEcommerceModel.Item = {
            item_name: 'seat',
            item_id: id,
            price: seatSelected.price,
            item_brand: this.DatalayerHelper.getBrandItem(model?.seatMapInfo?.segmentInfo?.departure?.code, model?.seatMapInfo?.segmentInfo?.id),
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: itemCategory2,
            item_category3: this.DatalayerUtilsService.getItemCategory3('seat', itemCategory2, id),
            item_variant: seatSelected.originalType.toLowerCase(),
            quantity: 1
        };
        return item;
    };
    setItemToAddToCart = (summarySeat, idOrigin, origin, itemCategory2) => {
        const id: string = this.CommonsUtilService.getIdItem('all');
        const item: DigitalDataEcommerceModel.Item = {
            item_name: 'seat',
            item_id: id,
            price: summarySeat.price,
            item_brand: this.DatalayerHelper.getBrandItem(origin, idOrigin),
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: itemCategory2,
            item_category3: this.DatalayerUtilsService.getItemCategory3('seat', itemCategory2, id),
            item_variant: summarySeat.variant ? summarySeat.variant.toLowerCase() : 'preassigned',
            quantity: Number(summarySeat.quantity)
        };
        return item;
    };
    setSeatAddToCart = (model: any): any => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        model?.seatInfo?.segments.forEach(segment => {
            const summarySeats = this.getSummarySeats(segment);
            const id: string = this.CommonsUtilService.getIdItem('all');
            const itemCategory2: string = `${segment?.departure?.code}-${segment?.arrival?.code}`;
            const origin: string = model?.seatMapInfo?.segmentInfo?.departure?.code ? model.seatMapInfo.segmentInfo.departure.code : `${segment?.departure?.code}-${segment?.arrival?.code}`;
            const idOrigin: any = model?.seatMapInfo?.segmentInfo?.id || null;

            summarySeats.forEach(summarySeat => {
                const item = this.setItemToAddToCart(summarySeat, idOrigin, origin, itemCategory2);
                digital_data_ecommerce.items.push(item);
            });
        });

        return digital_data_ecommerce;
    };

    getSummarySeats = (segment: any) => {
        const summarySeats = [];
        segment.passengers.forEach(passenger => {
            const price = passenger.seatPrice;
            const seatType = this.getTypeSeat(passenger);

            if (summarySeats.length === 0) {
                summarySeats.push({ variant: seatType, price: price, quantity: 1 });
            } else {
                let findSummarySeat = false;
                summarySeats.forEach(summarySeat => {
                    if (!findSummarySeat && summarySeat.variant === seatType) {
                        summarySeat.quantity += 1;
                        findSummarySeat = true;
                    }
                });
                if (!findSummarySeat) {
                    summarySeats.push({ variant: seatType, price: price, quantity: 1 });
                }
            }
        });
        return summarySeats;
    };

    getTypeSeat = (passenger: any): string => {
        const flowApp = this.localStorageService.get('flowApp');
        const isCheckinFlow = flowApp === this.AncillariesConstants.APPLICATION_FLOW.CHECKIN;
        const originalType = passenger?.currentSeat?.originalType;
        const seatType = passenger?.currentSeat?.seatType;
        let typeSeat: string = '';

        typeSeat = originalType ? originalType : seatType;

        if (isCheckinFlow && typeSeat.trim() === '') typeSeat = 'standard';
        return typeSeat;
    };

}

